import { BreederInfoReward } from './breeder-info-reward';

export class BreederInfo {
  public id: number;
  public name: string;
  public points: number;
  public pointsRankName: string;
  public rewards: BreederInfoReward[];

  constructor() {
  }
}
